import * as React from 'react';
import { NovaContextProvider } from './NovaContextProvider';

export function wrapInNovaProvider(renderMainComponent: () => JSX.Element): () => JSX.Element {
    return () => <NovaContextProvider>{renderMainComponent()}</NovaContextProvider>;
}
